<template>
  <v-card class="pa-5 margin-bottom" v-if="!loading">
    <h4>Filter</h4>
    <v-row class="mx-2 mt-3">
      <v-col cols="4">
        <v-select
            :items="roleOptions"
            label="Role"
            item-text="label"
            item-value="value"
            v-model="filter.role"
            @change="filterUsers"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.value }} </span>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            > (+ {{ filter.role }} others)
        </span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="4">
        <v-select
            item-value="label"
            item-text="label"
            :items="tags"
            label="Tags"
            v-model="filter.filterTags"
            multiple
            @focusout="filterUsers"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.label }} </span>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            > (+ {{ filter.filterTags.length - 1 }} others)
        </span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
            :items="allUsers"
            item-text="email"
            item-value="id"
            v-model.trim="userArray"
            label="Users"
            multiple
            return-object
            @focusout="addUser"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.name }} </span>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            > (+ {{ userArray.length - 1 }} others)
        </span>
          </template>
          <template v-slot:prepend-item>
            <v-list-item
                ripple
                @mousedown.prevent
                @click="handleSelectAllClick"
            >
              <v-list-item-action>
                <v-icon color="indigo darken-4">
                  {{ toggleAllIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-end mt-0 pt-0">
        <v-btn class="justify-content-end generate-btn-margin" small color="primary"
               @click="resetFilter">Reset
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>

import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "UserPermissionsFilterCard",
  data() {
    return {
      roleOptions: [
        {label: 'Demo', value: 'demo'},
        {label: 'Admin', value: 'admin'},
        {label: 'Customer', value: 'customer'},
        {label: 'Superadmin', value: 'super_admin'},
      ],
      userArray: [],
      filter: {
        role: null,
        filterTags: [],
      },
    }
  },
  computed: {
    ...mapState('userPermissions', ['allUsers', 'tags', 'allUserTableList', 'staticUserTableList', 'loading']),
    toggleAllIcon() {
      if (this.userArray?.length === this.allUsers?.length) return 'mdi-close-box'
      if (this.userArray?.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  watch:{
    allUserTableList(){
      if (this.allUserTableList.length > 0){
      this.userArray = this.allUserTableList
    }
    }
  },
  async mounted() {
    await this.fetchAllTags()
    await this.fetchAllUsers();
  },
  methods: {
    ...mapMutations('userPermissions', ['setFilteredUsers']),
    ...mapActions('userPermissions', ['fetchAllTags', 'fetchAllUsers']),
    async resetFilter() {
      this.filter.filterTags = []
      this.filter.role = null
      this.userArray = []
      await this.setFilteredUsers(this.userArray)
      await this.fetchAllUsers()
    },
    async addUser(){
      await this.setFilteredUsers(this.userArray)
    },
    async filterUsers() {
      if (this.filter.role) {
        this.userArray = this.staticUserTableList?.filter(user => user?.role === this.filter.role)
      }
      if (this.filter.filterTags?.length > 0) {
        let tagFilterUsers = []
        this.allUsers.forEach(user => {
          if (Object.values(this.filter.filterTags).every(tag => user.tags.includes(tag))) {
            tagFilterUsers.push(user)
          }
        })
        this.userArray = tagFilterUsers
      }
      await this.setFilteredUsers(this.userArray)
    },
    handleSelectAllClick() {
      if (this.userArray.length === this.allUsers.length) {
        this.userArray = []
      } else {
        this.userArray = this.allUsers
      }
    },
  },
}
</script>

<style>
.justify-content-end {
  justify-content: end;
}

.margin-bottom {
  margin-bottom: 10px;
}

.generate-btn-margin {
  margin: 0 15px;
}

::v-deep .input-width {
  max-width: 150px;
}
</style>